"use client";

import axios from "axios";
import { TOKEN_KEY } from "@/constants/auth";

/**
 * سابقه‌ی جستجو در دیتابیس.
 * - کاربر واردشده: با توکن (Authorization) شناسایی می‌شود.
 * - بازدیدکننده‌ی ناشناس: با شناسه‌ی تصادفی داخل کوکی `search_visitor` (هدر X-Visitor-Id).
 */

const BASE = `${process.env.NEXT_PUBLIC_API_URL}/search/recent`;
const VISITOR_COOKIE = "search_visitor";
const VISITOR_RE = /^[A-Za-z0-9-]{16,64}$/;

const randomId = (): string => {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return Array.from({ length: 4 }, () => Math.random().toString(16).slice(2, 10).padEnd(8, "0")).join("-");
};

/** شناسه‌ی بازدیدکننده را از کوکی می‌خواند؛ اگر نبود می‌سازد و برای ۲ سال ذخیره می‌کند */
export const getVisitorId = (): string => {
    const found = document.cookie.split("; ").find((c) => c.startsWith(`${VISITOR_COOKIE}=`));
    if (found) {
        const v = decodeURIComponent(found.slice(VISITOR_COOKIE.length + 1));
        if (VISITOR_RE.test(v)) return v;
    }
    const id = randomId();
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${VISITOR_COOKIE}=${id}; max-age=63072000; path=/; SameSite=Lax${secure}`;
    return id;
};

const http = axios.create({ headers: { Accept: "application/json" }, timeout: 8000 });

http.interceptors.request.use((config) => {
    if (typeof window !== "undefined") {
        const token = localStorage.getItem(TOKEN_KEY);
        if (token) config.headers.Authorization = `Bearer ${token}`;
        config.headers["X-Visitor-Id"] = getVisitorId();
    }
    return config;
});

/** لیست جستجوهای اخیر (جدیدترین اول). در صورت خطا null برمی‌گرداند */
export const fetchRecentSearches = async (limit = 30): Promise<string[] | null> => {
    try {
        const res = await http.get<{ data: string[] }>(BASE, { params: { limit } });
        return Array.isArray(res.data?.data) ? res.data.data.filter((x) => typeof x === "string") : [];
    } catch {
        return null;
    }
};

/** ثبت یک عبارت. replaces: عبارت ناقصی که چند لحظه پیش هنگام تایپ ثبت شده بود */
export const saveRecentSearch = async (term: string, replaces?: string): Promise<void> => {
    try {
        await http.post(BASE, { term, replaces });
    } catch {
        /* شکست شبکه نباید جستجو را مختل کند */
    }
};

export const deleteRecentSearch = async (term: string): Promise<void> => {
    try {
        await http.delete(BASE, { params: { term } });
    } catch {
        /* ignore */
    }
};

export const clearRecentSearches = async (): Promise<void> => {
    try {
        await http.delete(`${BASE}/all`);
    } catch {
        /* ignore */
    }
};
